import type { PayoutStatusDTO } from "../../domain/contracts";

export const PAYOUT_STATUS_LABELS: Record<PayoutStatusDTO, string> = {
  draft: "ຮ່າງ",
  pending_approval: "ລໍຖ້າອະນຸມັດ",
  approved: "ອະນຸມັດແລ້ວ",
  paid: "ຈ່າຍແລ້ວ",
  cancelled: "ຍົກເລີກ",
};

export function formatPayoutStatusLabel(
  status: PayoutStatusDTO | null | undefined,
): string {
  if (!status) return "ຍັງບໍ່ມີ";
  return PAYOUT_STATUS_LABELS[status] ?? status;
}
